<script>
import FlowChip from '@/components/FlowChip.vue'
import ShowStatus from '@/components/ShowStatus.vue'
import { EventBus, Topics, Types } from '@/event-bus'
import auth from '@/utils/auth'
import http from '@/utils/http'

export default {
  name: 'EquipamentoPainelRelacionamento',
  components: { FlowChip, ShowStatus },
  props: {
    equipamentoId: {
      type: String,
      required: true,
    },
    equipamento: {
      type: Object,
      required: true,
    },
    localId: {
      type: String,
      required: true,
    },
    equipamentoStatus: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tiposSensores: {},
      loading: true,
      data: {
        views: [],
        notificacaoAcao: [],
        notificacaoExpressao: [],
        notificacaoValorAssociado: [],
        sensoresVirtuais: [],
      },
      dadosSensoresExibir: null,
      loadingDadosSensoresExibir: false,
      notificacoes: [],
      notificacaoTypeMap: {
        ACAO: {
          label: 'Ação',
          color: '#0066FF26',
        },
        EXPRESSAO: {
          label: 'Expressão',
          color: '#00BB7726',
        },
        VALOR_ASSOCIADO: {
          label: 'Sensor',
          color: '#730CF126',
        },
      },
      sensorStatusCache: {},
      motoBombaConfig: null,
    }
  },
  async beforeMount() {
    this.equipamentoStatus.sensores.forEach((e) => {
      this.sensorStatusCache[e.id] = e
    })

    await this.loadTiposSensores()
      // eslint-disable-next-line no-unused-vars
      .then((e) => this.loadData())

    this.motoBombaConfig = this.equipamento.config.find(
      (e) => e.configName === 'MotoBombaConfig'
    )?.config?.value
  },
  methods: {
    loadTiposSensores() {
      return http.get('tiposSensores').then((response) => {
        this.tiposSensores = response.tiposSensores.reduce((acc, e) => {
          acc[e.id] = e
          return acc
        }, {})
      })
    },
    pushDashboard(view) {
      if (auth.canView()) {
        this.$router.push({
          name: 'ViewComponentes',
          params: {
            viewId: view.id,
            localId: this.localId,
          },
        })
      } else {
        this.$router.push({
          name: 'ViewComponentesShow',
          params: {
            viewId: view.id,
            localId: this.localId,
          },
        })
      }
    },
    copiarValor(data) {
      const el = document.createElement('textarea')
      el.value = data
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)

      EventBus.$emit(Topics.NOTIFICATIONS, {
        message: 'Valor copiado',
        type: Types.INFO,
      })
    },
    async loadSensoresVirtuaisExibicao() {
      const sensoresExibir = this.data.sensoresVirtuais.filter(
        (e) => e.exibirPainelEquipamento === true
      )

      if (sensoresExibir.length === 0) {
        return
      }

      this.loadingDadosSensoresExibir = true

      const tasks = sensoresExibir.map((e) => {
        return http.get(`sensor/virtual/${e.id}/evaluate`).then((response) => ({
          ...e,
          evaluate: response,
        }))
      })

      const dadosExibir = await Promise.all(tasks)

      this.loadingDadosSensoresExibir = false

      if (dadosExibir != null && dadosExibir.length > 0) {
        this.dadosSensoresExibir = dadosExibir
      }
    },
    async loadData() {
      this.loading = true
      await http
        .get(`equipamento/${this.equipamentoId}/painel-relacionamento`)
        .then((e) => {
          this.data = e

          const temp = [
            ...e.notificacaoAcao.map((e) => ({ ...e, types: ['ACAO'] })),
            ...e.notificacaoExpressao.map((e) => ({
              ...e,
              types: ['EXPRESSAO'],
            })),
            ...e.notificacaoValorAssociado.map((e) => ({
              ...e,
              types: ['VALOR_ASSOCIADO'],
            })),
          ]

          const results = {}

          temp.forEach((e) => {
            if (!results[e.titulo]) {
              results[e.titulo] = e
            } else {
              results[e.titulo].types = [...results[e.titulo].types, ...e.types]
            }
          })

          this.notificacoes = Object.values(results).sort((a, b) =>
            a.titulo.localeCompare(b.titulo)
          )
        })
        .finally(() => (this.loading = false))
        .then(() => {
          return this.loadSensoresVirtuaisExibicao()
        })
    },
  },
}
</script>

<template>
  <div>
    <div v-if="loading" style="text-align: center">
      <md-progress-spinner
        :md-diameter="500"
        :md-stroke="15"
        md-mode="indeterminate"
      />
    </div>
    <div v-if="!loading" class="ml-4 mr-4">
      <div v-if="dadosSensoresExibir">
        <div class="row" style="align-items: center">
          <div class="md-title">Compilação de dados</div>
        </div>

        <div v-if="loadingDadosSensoresExibir" style="text-align: center">
          <md-progress-spinner
            :md-diameter="40"
            :md-stroke="4"
            md-mode="indeterminate"
          />
        </div>

        <div v-if="!loadingDadosSensoresExibir" class="md-layout md-gutter">
          <div
            v-for="dadoSensorVirtual in dadosSensoresExibir"
            :key="dadoSensorVirtual.id"
            class="md-layout-item md-small-size-50 md-size-20 mt-1"
          >
            <md-card style="margin: 0">
              <md-ripple>
                <div class="row m-2" style="text-align: left" />
                <div class="md-layout m-2">
                  <div class="md-layout-item">
                    <div class="row">
                      <div class="col-6">
                        <p class="md-subheading">
                          {{ dadoSensorVirtual.titulo }}
                        </p>
                      </div>
                      <div class="col-6" style="text-align: center">
                        <span class="md-headline">
                          {{ dadoSensorVirtual.evaluate.result }}
                        </span>
                      </div>
                    </div>
                    <div class="md-caption" style="font-size: 0.9rem">
                      {{ dadoSensorVirtual.descricao }}
                    </div>
                  </div>
                </div>
                <div class="md-layout m-2" />
              </md-ripple>
            </md-card>
          </div>
        </div>
      </div>

      <div class="row" style="align-items: center">
        <div class="col-6">
          <div class="row">
            <div class="md-title">Sensores</div>
            <div class="inner_badge ml-1">
              {{ equipamento.sensores.length }}
            </div>
          </div>
        </div>
        <div class="col-6" style="text-align: right">
          <md-button
            class="md-primary md-raised"
            @click="
              $router.push({
                name: 'EquipamentoSensorNovo',
                params: {
                  equipamentoId: equipamentoId,
                  localId: localId,
                },
              })
            "
          >
            <md-icon>add</md-icon>
            Sensor
          </md-button>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div
          v-for="sensor in equipamento.sensores"
          :key="sensor.id"
          class="md-layout-item md-small-size-50 md-size-20 mt-1"
        >
          <md-card
            style="margin: 0"
            md-with-hover
            @click.native.stop="
              $emit('show-sensor', {
                sensor,
                status: sensorStatusCache[sensor.id],
              })
            "
          >
            <md-ripple>
              <div class="row m-2" style="text-align: left">
                <FlowChip
                  v-if="sensorStatusCache[sensor.id]"
                  :value="sensorStatusCache[sensor.id].severity"
                  :config="{
                    0: { label: 'Ativo', color: '#4CAF50' },
                    1: { label: 'Aviso', color: '#FF9800' },
                    2: { label: 'Travado', color: '#F44336' },
                  }"
                />

                <FlowChip
                  class="ml-1 mb-1"
                  :value="+sensor.visibilidadeGrafico"
                  :config="{
                    0: { label: 'Gráfico', color: '#F44336' },
                    1: { label: 'Gráfico', color: '#4CAF50' },
                  }"
                />
              </div>
              <div class="md-layout m-2">
                <div class="md-layout-item">
                  <p class="md-subheading">
                    {{ sensor.descricao }}
                  </p>
                  <div class="md-caption" style="font-size: 0.9rem">
                    {{ sensor.codigoIntegracao }}
                    <div class="inner-ball" />

                    {{
                      tiposSensores[sensor.tipoSensor].tipo || 'Carregando...'
                    }}
                  </div>
                </div>
              </div>

              <div class="md-layout m-2" />
            </md-ripple>
          </md-card>
        </div>
      </div>

      <br />
      <hr />

      <div class="row" style="align-items: center">
        <div class="col-6">
          <div class="row">
            <div class="md-title">Ações</div>
            <div class="inner_badge ml-1">
              {{ equipamento.botoesAcaoEquipamento.length }}
            </div>
          </div>
        </div>
        <div class="col-6" style="text-align: right">
          <md-button
            class="md-primary md-raised"
            @click="
              $router.push({
                name: 'EquipamentoAcaoNovo',
                params: {
                  equipamentoId: equipamentoId,
                  localId: localId,
                },
              })
            "
          >
            <md-icon>add</md-icon>
            Ação
          </md-button>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div
          v-for="acao in equipamento.botoesAcaoEquipamento"
          :key="acao.id"
          class="md-layout-item md-small-size-100 md-size-20 mt-1"
        >
          <md-card
            style="margin: 0"
            md-with-hover
            @click.native.stop="
              $router.push({
                name: 'EquipamentoAcaoEditar',
                params: {
                  equipamentoId: equipamentoId,
                  localId: localId,
                  acaoId: acao.id,
                },
              })
            "
          >
            <div class="p-2">
              <div class="row">
                <div class="col-1">
                  <md-icon
                    :style="{
                      ['background-color']: acao.cor,
                      ['border-radius']: '2px',
                      ['min-height']: '1vh',
                      ['min-width']: '1vh',
                    }"
                  />
                </div>

                <div class="col">
                  <p class="md-subheading">
                    {{ acao.nomeExibicao }}
                  </p>
                </div>
              </div>

              <div class="row" style="align-items: center">
                <div class="col-9 pr-0">
                  <p
                    class="md-caption"
                    style="
                      font-size: 0.9rem;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                    "
                  >
                    {{ acao.acao }}
                  </p>
                </div>

                <div class="col-3 p-0" style="text-align: center">
                  <md-button
                    class="md-icon-button button-with-border"
                    @click.stop="() => copiarValor(acao.acao)"
                  >
                    <md-icon>content_copy</md-icon>
                  </md-button>
                </div>
              </div>
            </div>
          </md-card>
        </div>
      </div>

      <br />
      <hr />

      <div v-if="motoBombaConfig">
        <div class="row" style="align-items: center">
          <div class="col-6 mt-2">
            <div class="row">
              <div class="md-title">Ações Moto Bomba</div>
              <div class="inner_badge ml-1">
                {{ equipamento.botoesAcaoEquipamento.length }}
              </div>
            </div>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div
            v-for="acao in motoBombaConfig.comandos"
            :key="acao.titulo"
            class="md-layout-item md-small-size-100 md-size-20 mt-1"
          >
            <md-card style="margin: 0">
              <div class="p-2">
                <div class="row">
                  <div class="col">
                    <p class="md-subheading">
                      {{ acao.titulo }}
                    </p>
                  </div>
                </div>

                <div class="row" style="align-items: center">
                  <div class="col-9 pr-0">
                    <p
                      class="md-caption"
                      style="
                        font-size: 0.9rem;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                      "
                    >
                      {{ acao.comando }}
                    </p>
                  </div>

                  <div class="col-3 p-0" style="text-align: center">
                    <md-button
                      class="md-icon-button button-with-border"
                      @click.stop="() => copiarValor(acao.comando)"
                    >
                      <md-icon>content_copy</md-icon>
                    </md-button>
                  </div>
                </div>
              </div>
            </md-card>
          </div>
        </div>

        <br />
        <hr />
      </div>

      <div class="row" style="align-items: center">
        <div class="col-6">
          <div class="row">
            <div class="md-title">Notificações</div>
            <div class="inner_badge ml-1">
              {{ notificacoes.length }}
            </div>
          </div>
        </div>

        <div class="col-6" style="text-align: right">
          <md-button
            class="md-primary md-raised"
            @click="
              $router.push({
                name: 'NotificacaoNovo',
                params: { localId: localId },
              })
            "
          >
            <md-icon>add</md-icon>
            Notificação
          </md-button>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div
          v-for="notificacao in notificacoes"
          :key="notificacao.id"
          class="md-layout-item md-small-size-100 md-size-20 mt-1"
        >
          <md-card
            style="margin: 0"
            md-with-hover
            @click.native.stop="$emit('show-notificacao', notificacao)"
          >
            <md-ripple>
              <div class="md-layout m-2">
                <div class="md-layout-item md-size-65 mb-2">
                  <p class="md-subheading">
                    {{ notificacao.notificacao.identificacao }}
                  </p>

                  <div class="md-caption" style="font-size: 0.9rem">
                    {{ notificacao.notificacao.titulo }}
                  </div>
                </div>
              </div>
              <div class="m-2 pl-3">
                <div class="row">
                  <div
                    v-for="type in notificacao.types"
                    :key="type"
                    class="chip ml-1 mr-1"
                    :style="{
                      'background-color': notificacaoTypeMap[type].color,
                    }"
                  >
                    {{ notificacaoTypeMap[type].label }}
                  </div>
                </div>
              </div>
            </md-ripple>
          </md-card>
        </div>
      </div>

      <br />
      <hr />

      <div class="row" style="align-items: center">
        <div class="col-6">
          <div class="row">
            <div class="md-title">Dashboards</div>
            <div class="inner_badge ml-1">
              {{ data.views.length }}
            </div>
          </div>
        </div>

        <div class="col-6" style="text-align: right">
          <md-button
            class="md-primary md-raised"
            @click="
              $router.push({
                name: 'ViewIndex',
                params: { localId: localId },
                query: { openSlider: 1 },
              })
            "
          >
            <md-icon>add</md-icon>
            Dashboard
          </md-button>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div
          v-for="view in data.views"
          :key="view.id"
          class="md-layout-item md-small-size-50 md-size-20 mt-1"
        >
          <md-card
            style="margin: 0"
            md-with-hover
            @click.native="() => pushDashboard(view)"
          >
            <md-ripple>
              <div class="md-layout m-2">
                <div class="md-layout-item md-size-65 mb-2">
                  <p class="md-subheading">
                    {{ view.titulo }}
                  </p>
                  <div class="md-caption" style="font-size: 0.9rem">
                    {{ view.descricao }}
                  </div>
                </div>
              </div>
            </md-ripple>
          </md-card>
        </div>
      </div>

      <br />
      <hr />

      <div class="row" style="align-items: center">
        <div class="col-8">
          <div class="row">
            <div class="md-title">Sensores Virtuais</div>
            <div class="inner_badge ml-1">
              {{ data.sensoresVirtuais.length }}
            </div>
          </div>
        </div>

        <div class="col" style="text-align: right">
          <md-button
            class="md-primary md-raised"
            @click="
              $router.push({
                name: 'SensorVirtualCreate',
                params: {
                  equipamentoId: equipamentoId,
                  localId: localId,
                },
              })
            "
          >
            <md-icon>add</md-icon>
            Sensor Virtual
          </md-button>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div
          v-for="sensorVirtual in data.sensoresVirtuais"
          :key="sensorVirtual.id"
          class="md-layout-item md-small-size-100 md-size-20 mt-1"
        >
          <md-card
            style="margin: 0"
            md-with-hover
            @click.native="
              $router.push({
                name: 'SensorVirtualEdit',
                params: {
                  equipamentoId: equipamentoId,
                  sensorVirtualId: sensorVirtual.id,
                  localId: localId,
                },
              })
            "
          >
            <md-ripple>
              <div class="md-layout m-2">
                <div class="md-layout-item md-size-100 mb-2">
                  <p class="md-subheading">
                    {{ sensorVirtual.titulo }}
                  </p>
                  <div class="md-caption" style="font-size: 0.9rem">
                    {{ sensorVirtual.descricao }}
                  </div>
                </div>
              </div>
            </md-ripple>
          </md-card>
        </div>
      </div>

      <br />
      <hr />
    </div>
  </div>
</template>

<style scoped lang="scss">
hr {
  border: 0;
  height: 1px;
  background: #dcdcdc;
}

.inner-ball {
  $size: 6px;
  margin-bottom: 0.1rem;

  width: $size;
  height: $size;
  background-color: #dcdcdc;
  border-radius: 50%;
  display: inline-block;
}

.inner_badge {
  text-align: center;

  margin: auto;
  padding: 0.1rem 0.4rem 0.1rem 0.4rem;

  font-size: 0.9rem;

  background-color: #1b1f26b8;
  color: white;
  font-weight: bold;
  border-radius: 20px;
}

.button-with-border {
  border: 1px solid #e4e4e7;
  border-radius: 3px;
}

.chip {
  border-radius: 16px;
  background-color: #f1f1f1;

  color: #4d4d4d;

  font-size: 0.8rem;
  font-weight: 500;

  padding: 4px 8px;
}
</style>
